<template>
  <div id="authorityPage">
    <el-form label-width="100px" label-position="left">
      <el-form-item label="查看用户/组" style="margin-top: 20px;">
        <el-select placeholder="请选择" v-model="selectedVal" @change="selectOption" value-key="id">
          <el-option-group v-for="(item,index) in usersAndGroupsOptions" :key="index" :label="item.label">
            <el-option
              v-for="item2 in item.options"
              :key="item2.id" 
              :value="{id:item2.id,type:item2.type}"
              :label="item2.username||item2.groupname"
            >
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="管理员" v-if="selectedVal.type==='manage'">
        <el-checkbox checked disabled></el-checkbox>
      </el-form-item>
      <el-form-item label="群组" v-if="selectedVal.type==='manage'||selectedVal.type==='user'">
        <!-- {{selectedVal.authority.owner_group}} -->
        <span v-for="(item,index) in selectedVal.authority" :key="index" class="ingroup-span">{{item.owner_groupname}}-{{item.owner_groupid}}</span>
      </el-form-item>
      <el-form-item label="用户权限">
      </el-form-item>
      <el-form-item style="margin-top:0px;">
          <el-checkbox v-model="allcheckbox" @change="Allcheckbox">文件库</el-checkbox>
          <div style="margin:0;"></div>
            <el-checkbox @change="UploadFile" v-model="uploadFile" style="padding-right:30px;">上传文件</el-checkbox>
            <el-checkbox @change="ShareFile" v-model="shareFile" style="padding-right:30px">分享文件</el-checkbox>
            <el-checkbox @change="DeleteFile" v-model="deleteFile" style="padding-right:30px">删除文件</el-checkbox>
          <div style="margin: 15px 0;border-top: 1px solid #ddd;"></div>
          <el-checkbox v-model="ApplicationMarket" @change="Applicationmarket">应用市场</el-checkbox>
          <div style="margin:0;"></div>
            <el-checkbox v-model="PictureWarehouse" @change="Picturewarehouse" style="padding-right:30px;">图库</el-checkbox>
            <el-checkbox v-model="Appmonitor" @change="AppMonitor" style="padding-right:30px;">应用检测</el-checkbox>
          <div style="margin: 15px 0;border-top: 1px solid #ddd;"></div>
          <el-checkbox v-model="Other" @change="otherchange">其他</el-checkbox>
          <div style="margin:0;"></div>
            <el-checkbox v-model="UserManage" @change="Usermanage" style="padding-right:30px;">用户管理</el-checkbox>
            <el-checkbox v-model="GroupManage" @change="groupmanage" style="padding-right:30px;">组管理</el-checkbox>
      </el-form-item>
     
    </el-form>
  </div>
</template>

<script>
import {usersAndGroupsList,getAuthority} from "network/systemAuthority"
import {changeAuthority} from "network/systemAuthority"
import {mapGetters} from "vuex"
export default {
    name:"Authority",
    data(){
      return{
        allcheckbox:false,//文件库
        uploadFile:false,//上传文件
        shareFile:false, //分享文件
        deleteFile:false, //删除文件
        ApplicationMarket:false,//应用市场
        PictureWarehouse:false,//图库
        Appmonitor:false,//应用监测
        Other:false,//其他
        UserManage:false,//用户管理
        GroupManage:false,//组管理

        Fileobj:{ //文件权限对象
          a1:false,
          a2:false,
          a3:false
        },
        
        ApplicationMarketobj:{//应用市场对象
          b0:false,
          b1:false
        },
        Otherobj:{//其他对象
          c1:false,
          c2:false
        },

        //uploadFile:"",//上传
        //shareFile:"", //分享
        //deleteFile:"", //删除
        usersAndGroupsOptions:[],
        selectedVal:{
          type:"manage",
          id:"",
          authority:{}
        },
      }
    },
    created(){
      this.selectedVal.id=this.userID;
      //得到用户列表
      usersAndGroupsList({
        userID:this.userID
      }).then(res=>{
        console.log(res.data);
        let {data} = res;
        for(let index in data.userarray){
          if(data.userarray[index].type == "manage"){
            data.userarray[index].username = data.userarray[index].username+'（管理）';
          }else{
            data.userarray[index].username = data.userarray[index].username+'（普通用户）';
          }
         }
        for(let keyy in data.grouparray){
         data.grouparray[keyy].groupname = data.grouparray[keyy].groupname+'（组）';
        }
        console.log(data.userarray)
        for(let key in data){
          if(key==="userarray"){
            this.usersAndGroupsOptions.push({
             // label:"用户",
              options:data[key]
            })
          }else if(key==="grouparray"){
            this.usersAndGroupsOptions.push({
              //label:"组",
              options:data[key]
            })
          }
        }
      }),
      //得到权限
      this.toGetAuthority({
        userID:this.userID,
        type:"manage",
        nameID:this.userID
      })
    },
    computed:{
      ...mapGetters([
        'userID'
      ])
    },
    methods:{
      //复选框选择 文件库 全选
      Allcheckbox:function(){
      var array = [];
        if(this.allcheckbox == true){
          this.uploadFile = true;
          this.shareFile = true;
          this.deleteFile = true;
          //console.log(this.Fileobj,this.ApplicationMarketobj,this.Otherobj)
          array = [{type:true, name:'a1'}, {type:true, name:'a2'}, {type:true, name:'a3'}]
           const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
           console.log(array)
          //console.log(infos,'xxxx')
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
          this.uploadFile = false;
          this.shareFile = false;
          this.deleteFile = false;
          array = [{type:false, name:'a1'}, {type:false, name:'a2'}, {type:false, name:'a3'}]
          //console.log(this.Fileobj,this.ApplicationMarketobj,this.Otherobj)
           const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //上传文件复选框
      UploadFile:function(){
        //console.log(this.shareFile,1111)
        if(this.uploadFile == true && this.shareFile == true && this.deleteFile == true){
          this.allcheckbox = true;
        }else{
          this.allcheckbox = false;
        }
        var array = [];
        if(this.uploadFile == true){
          array = [{type:true, name:'a1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
           console.log(infos,11111)
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
          array = [{type:false, name:'a1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
           console.log(infos,2222)
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //分享文件复选框
      ShareFile:function(){
        if(this.uploadFile == true && this.shareFile == true && this.deleteFile == true){
          this.allcheckbox = true;
        }else{
          this.allcheckbox = false;
        }
        var array = [];
        if(this.shareFile == true){
          array = [{type:true, name:'a2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
          array = [{type:false, name:'a2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //删除文件复选框
      DeleteFile:function(){
        if(this.uploadFile == true && this.shareFile == true && this.deleteFile == true){
          this.allcheckbox = true;
        }else{
          this.allcheckbox = false;
        }
        var array = [];
        if(this.deleteFile == true){
          array = [{type:true, name:'a3'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
          array = [{type:false, name:'a3'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //复选框 应用市场 全选 ApplicationMarket
      Applicationmarket:function(){
        var array = [];
        if(this.ApplicationMarket == true){
          this.PictureWarehouse = true;
          this.Appmonitor = true;
          array = [{type:true, name:'b0'},{type:true, name:'b1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
           this.PictureWarehouse = false;
           this.Appmonitor = false;
           array = [{type:true, name:'b0'},{type:true, name:'b1'}]
           const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //图库 复选框 PictureWarehouse
      Picturewarehouse:function(){
         if(this.PictureWarehouse == true && this.Appmonitor == true){
          this.ApplicationMarket = true;
        }else{
           this.ApplicationMarket = false;
        }
        var array = [];
        if(this.PictureWarehouse == true){
          array = [{type:true, name:'b0'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
           array = [{type:false, name:'b0'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //应用监测 复选框
      AppMonitor:function(){
        if(this.Appmonitor == true && this.PictureWarehouse == true){
          this.ApplicationMarket = true;
        }else{
           this.ApplicationMarket = false;
        }
        var array = [];
        if(this.Appmonitor == true){
          array = [{type:true, name:'b1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
           array = [{type:false, name:'b1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },

      //复选框 其他 全选
      otherchange:function(){
        var array = [];
        if(this.Other == true){
          this.UserManage = true;
          this.GroupManagce = true;
          array = [{type:true, name:'c1'},{type:true, name:'c2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
          this.UserManage = false;
          this.GroupManage = false;
          array = [{type:false, name:'c1'},{type:false, name:'c2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //复选框 用户管理
      Usermanage:function(){
        if(this.UserManage == true && this.GroupManage == true){
          this.Other = true;
        }else{
          this.Other = false;
        }
        var array = [];
        if(this.UserManage == true){
          array = [{type:true, name:'c1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
           array = [{type:false, name:'c1'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      //复选框 组管理
      groupmanage:function(){
        if(this.UserManage == true && this.GroupManage == true){
          this.Other = true;
        }else{
          this.Other = false;
        }
        var array = [];
        if(this.GroupManage == true){
           array = [{type:true, name:'c2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }else{
           array = [{type:false, name:'c2'}]
          const infos = {
             userID:this.userID,
             id:this.selectedVal.id,
             quanxian:array
           };
          changeAuthority(infos).then(res=>{
            console.log(res,'返回值')
          })
        }
      },
      toGetAuthority(obj){
        getAuthority(obj).then(res=>{
          let {data} = res;
          let authorityObj = 'owner_group'||'grouparray';
         this.$set(this.selectedVal,'authority',data[authorityObj]);

         //console.log(res.data.owner_group,'res')
        //console.log(res.data.grouparray,res.data.userarray,'2222222')
       var array = [];
       if(res.data.userarray == undefined){
         console.log(res.data.grouparray,11111)
         for(var r = 0;r<res.data.grouparray.length;r++){
           if(res.data.grouparray[r].quanxian == '1'){
              array.push(res.data.grouparray[r].quanxian_code)
            }
         }
       }else{
         console.log(res.data.userarray,222222)
         for(var i = 0;i<res.data.userarray.length;i++){
         // console.log(res.data.userarray[i],'555555555555')
          for(var j = 0;j<res.data.userarray[i].length;j++){
            console.log(res.data.userarray[i][j].quanxian,res.data.userarray[i][j].quanxian_code,res.data.userarray[i][j].quanxian_name,'6666666')
            if(res.data.userarray[i][j].quanxian == '1'){
              array.push(res.data.userarray[i][j].quanxian_code)
            }
          }
        }
       }
        console.log(array,'xxxxxxqqqqq')
           this.uploadFile = false;
           this.shareFile = false;
           this.deleteFile = false;
           this.PictureWarehouse = false;
           this.Appmonitor = false;
           this.UserManage = false;
           this.GroupManage = false;
        for(var a = 0;a<array.length;a++){
          //console.log(array[a])
          if(array[a] == 'a1'){//上传文件 a1
              this.uploadFile = true;
          }else if(array[a] == 'a2'){//分享文件 a2
              this.shareFile = true;
          }else if(array[a] == 'a3'){ //删除文件 a3
              this.deleteFile = true;
          }else if(array[a] == 'b0'){//图库 b0
              this.PictureWarehouse = true;
          }else if(array[a] == 'b1'){//应用监测 b1
              this.Appmonitor = true;
          }else if(array[a] == 'c1'){//用户管理 c1
              this.UserManage = true;
          }else if(array[a] == 'c2'){//组管理 c2
              this.GroupManage = true;
          }
        }
         if(this.uploadFile == true && this.shareFile == true && this.deleteFile == true){
          this.allcheckbox = true;
        }else{
          this.allcheckbox = false;
        }
        if(this.Appmonitor == true && this.PictureWarehouse == true){
          this.ApplicationMarket = true;
        }else{
           this.ApplicationMarket = false;
        }
        if(this.UserManage == true && this.GroupManage == true){
          this.Other = true;
        }else{
          this.Other = false;
        }
        //console.log(array,'array')
         //let resdata=JSON.parse(JSON.stringify(this.selectedVal.authority));
         //console.log(this.selectedVal.authority,'xxxxxx')
        // console.log(data[authorityObj],data.owner_group,this.selectedVal,9998989888)
          // this.selectedVal.authority=data[authorityObj];
          // console.log(this.selectedVal.authority);
        })
      },
      selectOption(eleobj){
        console.log(eleobj)
        this.toGetAuthority({
          userID:this.userID,
          type:eleobj.type,
          nameID:eleobj.id
        });
      }
    }
}
</script>
<style scoped>
  .ingroup-span{
    margin-right: 20px;
  }
</style>